import * as React                     from 'react';

import { Container,
         HorizontalDividerVariants,
         horizontaldivider_variants } from 'src/components/common/horizontal-divider/ui';



type Props = {
  variant: HorizontalDividerVariants;
}
export const HorizontalDivider: React.FC<Props> = ({
  variant,
}) => {
  const lookAndFeel = horizontaldivider_variants.get(variant)!;

  return (
    <Container lookAndFeel = { lookAndFeel } />
  );
};
